<div *ngIf="columna == 'attributeSource'">
   <ng-multiselect-dropdown
                    placeholder="Atributo Origen"
                    [settings]="attrSourceSettings"
                    [data]="sourceAttributes"
                    [(ngModel)]="currentValue"
                    (onDropDownClose)="changeSelect()">
                  </ng-multiselect-dropdown>

</div>

<div *ngIf="columna == 'relation'">


            <div class="form-group">
              <label for="relacionesSimples" class="label">Entidad</label>


              <ng-multiselect-dropdown
                  placeholder="Entidad"
                  [settings]="attrSourceSettings"
                  [data]="entities"
                  [(ngModel)]="entityValue"
                  (onSelect)="changeSelect()">
                </ng-multiselect-dropdown>

            </div>
            <div class="form-group">
              <label for="relacionesSimples" class="label">Atributo</label>
   <ng-multiselect-dropdown
                 placeholder="Atributo Destino"
                 [settings]="attrSourceSettings"
                 [data]="targetAttributes"
                 [(ngModel)]="targetValue"
                 (onDropDownClose)="changeAtributeSelect()">
               </ng-multiselect-dropdown>
               </div>
</div>
